import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

import PackageAdditionalServiceEnum from '~/enums/PackageAdditionalServiceEnum'
import shipmentFindService from '~/utils/shipzeePro/shipmentFindService'
import { getFullYear } from '~/utils/date/parseDate'

export default function getInspectPackageDate(shipment: PackageInterface) {
  const serviceData = shipmentFindService(shipment, PackageAdditionalServiceEnum.InspectPackage)
  if (serviceData && serviceData.completed_at !== null) {
    return getFullYear(serviceData.completed_at)
  }

  return ''
}
